export default () => ({
    type: "CLEAR_CURRENT_VESSEL"
});